import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WebStorage } from "./web-storage";

@Injectable({
  providedIn: "root",
})
export class FavoriteDocumentsService {
  private webStorage = inject(WebStorage);

  private productDocumentsIdsSubject = new BehaviorSubject<string[]>(
    this.webStorage.productDocumentsIdsIncluded ?? [],
  );
  private productDocumentsFavoritesStatus = new BehaviorSubject<boolean>(
    this.webStorage.showDocumentsFavorites ?? false,
  );
  includedDocumentIds$ = this.productDocumentsIdsSubject.asObservable();
  productDocumentFavorites$ =
    this.productDocumentsFavoritesStatus.asObservable();

  setIdsIncluded(ids: string[]) {
    this.webStorage.productDocumentsIdsIncluded = ids ?? [];
    this.productDocumentsIdsSubject.next(
      this.webStorage.productDocumentsIdsIncluded,
    );
  }

  setFavoritesDocumentsStatus(status: boolean) {
    this.webStorage.showDocumentsFavorites = status;
    this.productDocumentsFavoritesStatus.next(
      this.webStorage.showDocumentsFavorites,
    );
  }

  remove(id: string) {
    if (id) {
      this.setIdsIncluded(
        this.webStorage.productDocumentsIdsIncluded.filter(
          (includedId) => includedId !== id,
        ),
      );
    }
  }
  add(id: string) {
    if (id) {
      const includedIds = this.webStorage.productDocumentsIdsIncluded;
      if (!includedIds.includes(id)) {
        this.setIdsIncluded([...includedIds, id]);
      }
    }
  }
}
